import { useLocation, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { Modal, Spin, message, Progress, Select, Drawer, Menu } from "antd";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { isMobile } from "react-device-detect";
import { MenuOutlined, SettingOutlined } from "@ant-design/icons";
import "./style.css";

import ConnectWallet from "../components/connect-wallet/ConnectWallet";

import cn from "../components/cn/common.json";
import en from "../components/en/common.json";
import po from "../components/po/common.json";

i18next.init({
  interpolation: { escapeValue: false },
  lng: "en",
  resources: {
    en: {
      common: en,
    },
    cn: {
      common: cn,
    },
    po: {
      common: po,
    },
  },
});

const Header = () => {
  let navigate = useNavigate();
  let location = useLocation();
  const { t, i18n }: any = useTranslation("common");
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [valueSelect, setValueSelect]: any = useState("en");

  const [isGeckonft, setgeckonft] = useState<boolean>(false);
  const [isExplore, setexplore] = useState<boolean>(false);
  const [isMynft, setmynft] = useState<boolean>(false);

  let pathName = location.pathname;

  useEffect(() => {
    if (pathName === "/") {
      setgeckonft(true);
    } else if (pathName === "/gecko-nft") {
      setexplore(true);
    } else if (pathName === "/my-nft") {
      setmynft(true);
    }
  }, [pathName]);

  const [open, setOpen] = useState(false);
  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleChange = (value: any) => {
    console.log(`selected ${value}`);
    i18n.changeLanguage(`${value}`);
    localStorage.setItem("valuelang", value);
    setValueSelect(value);
  };
  useEffect(() => {
    setValueSelect(localStorage.getItem("valuelang"));
    i18n.changeLanguage(localStorage.getItem("valuelang"));
  }, [valueSelect]);

  const goToMyNFT = () => {
    navigate("/my-nft");
  };
  const gotoExplore = () => {
    // navigate("/gecko-nft");

  };
  const gotoHome = () => {
    window.open("https://geckoinu.vip/");
    // navigate("/");
  };
  const gotoHome1 = () => {
    navigate("/");
  };




  const [current, setCurrent] = useState("nft");
  const onClick = (e: any) => {
    console.log("click ", e);
    setCurrent(e.key);
  };

  const [isModalOpen1, setIsModalOpen1] = useState(false);

  const showModal1 = () => {
    setIsModalOpen1(true);
  };

  const handleOk1 = () => {
    setIsModalOpen1(false);
  };

  const handleCancel1 = () => {
    setIsModalOpen1(false);
  };

  const gotoJoe = () => {
    window.open('https://joepegs.com/collections/avalanche/0x2da215293f66319facdf8fe41d99524a406d4c8f')
  }
  const gotoOpen = () => {
    window.open('https://opensea.io/collection/gecko-inu-nft-collection-1?tab=items')
  }
  const gotoHyper = () => {
    window.open('https://avax.hyperspace.xyz/collection/avax/007f119d-e48c-4390-9331-0c2bde2468c1')
  }

  return (
    <>
      <div className="header">
        {isMobile ? (
          <>
            <div className="logo" onClick={gotoHome}>
              <img src="../images/logo-nft.png?v=2" alt="" />
            </div>
            <div className="header-left-mb">
              <div className="menu-mobie" onClick={showDrawer}>
                <img src="../images/menu-mo.svg" alt="" />
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="header-left">
              <div className="logo" onClick={gotoHome}>
                <img src="../images/logo-nft.png?v=2" alt="" />
              </div>
              <div className="menu">
                <div
                  className={`wallpaper ${isGeckonft ? "menu-selected" : ""}`}
                  onClick={gotoHome1}
                >
                  Gecko nfts
                </div>
                <div className={`roundmap ${isExplore ? ('menu-selected') : ('')}`}
                  onClick={showModal1}
                >explore</div>
                <div
                  className={`roundmap ${isMynft ? "menu-selected" : ""}`}
                  onClick={goToMyNFT}
                >
                  my nfts
                </div>
              </div>
            </div>

            <div className="action">
              <div className="action-btn">
                <ConnectWallet />
              </div>
            </div>
          </>
        )}
      </div>
      <div className="line"></div>
      <Modal
        title=""
        visible={isModalVisible}
        onOk={handleOk}
        footer={false}
        onCancel={handleCancel}
        className="modal-lucky"
        width={720}
      >
        <div className="lucky">
          <img
            className="roundmap-img"
            src={t("content.t-30", { framework: "React" })}
            alt=""
          />
          <img className="roundmap-text" src="../images/rm-img.svg" alt="" />
        </div>
      </Modal>
      <Drawer title="" placement="right" onClose={onClose} open={open}>
        <div className="menu mb">
          <div className="wallpaper" onClick={gotoHome}>
            Gecko nfts
          </div>
          <div className="roundmap" onClick={showModal1}>
            explore
          </div>
          <div className="roundmap" onClick={goToMyNFT}>
            my nfts
          </div>
        </div>
        <div className="action">
          <div className="action-btn mb">
            <ConnectWallet />
            {/* <button className="btn-air mb" onClick={gotoAirdrop}>
                            {t('menu.menu-3', { framework: 'React' })}

                        </button> */}
            {/* <button className="buy-now mb" onClick={gotoSwap}>
                            {t('menu.menu-4', { framework: 'React' })}

                        </button> */}
            {/* <Select
                            value={valueSelect}
                            style={{
                                width: 180,
                            }}
                            popupClassName='select-lang'
                            onChange={handleChange}
                            options={[
                                {
                                    value: 'en',
                                    label: <div className="country">
                                        <img src="./images/en.png" alt="" />&ensp;  English
                                    </div>,
                                },
                                {
                                    value: 'po',
                                    label: <div className="country">
                                        <img src="./images/po.png" alt="" />&ensp;  Português
                                    </div>,
                                },
                                {
                                    value: 'cn',
                                    label: <div className="country">
                                        <img src="./images/china.png" alt="" />&ensp;  中文（简体）
                                    </div>,
                                },

                            ]}
                        /> */}
          </div>
        </div>
      </Drawer>
      <Modal
        wrapClassName="modal-ow"
        footer={false}
        title=""
        open={isModalOpen1}
        onOk={handleOk1}
        onCancel={handleCancel1}
      >
        <div className="modal-owner">
          <div className="modal-link">
            <div className="title-link">
              Explore NFTs
            </div>
            <div className="trade-link">
              <div className="item-trade" onClick={gotoJoe}>Trade on <p>Joepegs <p className="by-trade">by Trader Joe</p></p>

              </div>
              <div className="item-trade" onClick={gotoOpen}>Trade on <p>
                <img src="./images/nft/opensea.png" alt="" />
                OpenSea
              </p> </div>
              <div className="item-trade" onClick={gotoHyper}>Trade on <p>
                <img src="./images/nft/hyper.jpeg" alt="" />
                HyperSpace</p> </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default Header;
